<template>
  <div class="login-block">
    <div class="login-title">
      <h5>设置新密码</h5>
      <p>
        <span :class="{ ok: matching.len }">&#8226;&ensp;8-20位</span>&ensp;
        <span :class="{ ok: matching.num }">&#8226;&ensp;数字、</span>
        <span :class="{ ok: matching.char }">字母、</span>
        <span :class="{ ok: matching.sign }">符号</span>
        <span :class="{ ok: matching.num && matching.char && matching.sign }"
          >的组合</span
        >
      </p>
    </div>
    <el-form
      ref="resetPass"
      class="login-form"
      :model="resetPass"
      :rules="rules"
      :show-message="false"
      size="medium"
    >
      <el-form-item prop="password" class="pass">
        <el-input
          v-model="resetPass.password"
          maxlength="20"
          placeholder="新密码"
          show-password
          v-on:keyup.enter.native="submitForm"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item prop="checkpass" class="pass">
        <el-input
          v-model="resetPass.checkpass"
          maxlength="20"
          placeholder="确认密码"
          show-password
          v-on:keyup.enter.native="submitForm"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>

    <div class="link-box clearfix"></div>
    <div class="btn-box">
      <v-button @click="submitForm" :loading="loading">完&emsp;成</v-button>
    </div>
  </div>
</template>

<script>
import aes from '@/uitls/aes'
import vButton from './vButton.vue'

export default {
  components: {
    vButton
  },
  data() {
    // 输入新密码验证
    const password = (rule, value, callback) => {
      let reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,20}$/
      if (value !== '') {
        if (!reg.test(value)) {
          callback(new Error('密码过于简单'))
        } else {
          callback()
        }
      } else {
        callback(new Error('密码不能为空'))
      }
    }
    // 确认密码密码验证
    const checkPass = (rule, value, callback) => {
      if (value != this.resetPass.password) {
        callback(new Error('两次密码不一致'))
      } else if (value == '') {
        callback(new Error('密码不能为空'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      isDiasbled: true,
      errMessage: '',
      // 表单
      resetPass: {
        password: '',
        checkpass: ''
      },
      rules: {
        password: [{ validator: password, trigger: 'blur' }],
        checkpass: [{ validator: checkPass, trigger: 'blur' }]
      },
      // matching result
      matching: {
        len: false,
        num: false,
        char: false,
        sign: false
      }
    }
  },
  watch: {
    'resetPass.password'() {
      let reg_blank = /\s+/g
      let reg_length = /\S{8,20}/
      let reg_num = /\d+/
      let reg_char = /[a-zA-Z]+/
      let reg_sign = /[~!@#$%^&*()_+`\-={}:";'<>?,.\/]+/

      let str = this.resetPass.password
      reg_blank.test(str) &&
        (this.resetPass.password = str.replace(reg_blank, ''))
      str = this.resetPass.password

      this.matching.len = reg_length.test(str)
      this.matching.num = reg_num.test(str)
      this.matching.char = reg_char.test(str)
      this.matching.sign = reg_sign.test(str)
    },
    'resetPass.checkpass'() {
      let reg_blank = /\s+/g

      let str = this.resetPass.checkpass
      reg_blank.test(str) &&
        (this.resetPass.checkpass = str.replace(reg_blank, ''))
    }
  },
  methods: {
    doLoading() {
      this.loading = true
    },
    doCloseLoading() {
      this.loading = false
    },
    submitForm() {
      this.$refs.resetPass.validate(valid => {
        if (valid) {
          this.doLoading()
          //// 请求响应之前 不能重复发送请求
          let resetInfo = JSON.parse(sessionStorage.getItem('resetInfo'))
          this.$http
            .post('/user-server/user/forgetPwd', {
              password: aes.Encrypt(this.resetPass.password),
              phoneNo: resetInfo.telNumber,
              verificationCode: resetInfo.verCode
            })
            .then(res => {
              this.doCloseLoading()
              if (res.data.code == 200) {
                let json = {}
                json.user = resetInfo.telNumber
                //// sessionStorage.setItem("resetsuccess", resetInfo.telNumber);
                // redirect to recoverySuccess
                this.$emit('update', 'recoveryS')
                this.$message.success(res.data.message)
              } else {
                this.$message.error(res.data.message)
              }
            })
            .catch(err => {
              this.doCloseLoading()
              console.log('ERROR', err)
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../styles/login.scss';
</style>
<style lang="scss">
@import '../styles/form.scss';
</style>



// WEBPACK FOOTER //
// src/views/index/components/recoveryB.vue